import { FormControl, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { ReactComponent as ExpandArrowIcon } from '../../assets/icons/iconExpandArrow.svg';
import { Container } from './styles';
import { BRAZILIAN_STATES } from '../../constants';

export interface DropDownListProps {
  placeholderTitle: string;
  elementId?: string;
  onChange: (ufCode: number) => void;
}

export function DropListStatesBrazillian({
  placeholderTitle,
  elementId,
  onChange = () => {},
}: DropDownListProps) {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.colors.background_white,
        color: theme.colors.secondary,
      },
    },
  };

  const handleOpen = () => {
    setIsOpen(true);
    document.body.classList.add('no-scroll');
  };

  const handleClose = () => {
    setIsOpen(false);
    document.body.classList.remove('no-scroll');
  };

  const handleScroll = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      document.body.classList.remove('no-scroll');
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Container id={elementId}>
      <FormControl fullWidth>
        <Select
          open={isOpen}
          onOpen={handleOpen}
          onClose={handleClose}
          name="state"
          classes={{ select: 'select-style' }}
          defaultValue=""
          MenuProps={MenuProps}
          displayEmpty
          IconComponent={ExpandArrowIcon}
          onChange={(event) => onChange(Number(event.target.value))}>
          <MenuItem disabled value="">
            {placeholderTitle}
          </MenuItem>
          {BRAZILIAN_STATES.map((state) => (
            <MenuItem value={state.ufCode} key={state.ufCode}>
              {state.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Container>
  );
}
